import { Fragment, ReactNode } from 'react';
import { Dialog, DialogPanel, Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import ninetysix from '../../../public/white-logo.png';

export function MobilePanel(props: {
  show: boolean;
  onClose: (value: ((prevState: boolean) => boolean) | boolean) => void;
  onClick: () => void;
  children?: ReactNode;
}) {
  return (
    <Transition.Root show={props.show} as={Fragment}>
      <Dialog as="div" className="relative z-50 lg:hidden" onClose={props.onClose}>
        <Transition.Child
          as={Fragment}
          enter="transition-opacity ease-linear duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity ease-linear duration-300"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-900/80" />
        </Transition.Child>

        <div className="fixed inset-0 flex">
          <Transition.Child
            as={Fragment}
            enter="transition ease-in-out duration-300 transform"
            enterFrom="-translate-x-full"
            enterTo="translate-x-0"
            leave="transition ease-in-out duration-300 transform"
            leaveFrom="translate-x-0"
            leaveTo="-translate-x-full"
          >
            <DialogPanel className="relative mr-4 flex w-[90%]">
              <div className="absolute left-full top-0 flex w-16 justify-center pt-5 safe-area-mt">
                <button type="button" className="-m-2.5 p-2.5" onClick={props.onClick}>
                  <span className="sr-only">Close sidebar</span>
                  <XMarkIcon className="h-6 w-6 text-white" aria-hidden="true" />
                </button>
              </div>
              {/* Sidebar component, swap this element with another sidebar if you like */}
              <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-navbarGray px-6 pb-4 safe-area-top safe-area-bottom">
                <div className="flex h-16 shrink-0 items-center">
                  <img
                    className="h-10 w-auto"
                    src={ninetysix}
                    alt="Digital InHouse"
                  />
                </div>
                <nav className="flex flex-1 flex-col">{props.children}</nav>
              </div>
            </DialogPanel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
